import { isSameIdSelection } from '../../UserActivity.meta';

export const shouldPruneActivitySelection = (
  appliedActivityIds: string[],
  draftActivityIds: string[],
  appliedUserIds: string[],
  draftUserIds: string[],
): boolean =>
  isSameIdSelection(appliedActivityIds, draftActivityIds) &&
  isSameIdSelection(appliedUserIds, draftUserIds);

export const resetActivitySelection = (availableIds: string[]) => ({
  selectedIds: [...availableIds],
  searchSelectedIds: [...availableIds],
});
